import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GalleryVerticalEnd } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { LoginForm } from '@/components/login-form'

export default function LoginPage() {
  const [loginError, setLoginError] = useState<string | null>(null)
  const [loginLoading, setLoginLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleLogin = async (username: string, password: string) => {
    setLoginError(null)
    setLoginLoading(true)
    try {
      const user = await login(username, password)
      navigate(user.must_change_password ? '/set-password' : '/dashboard')
    } catch (err: unknown) {
      setLoginError(err instanceof Error ? err.message : 'שגיאה בהתחברות')
    } finally {
      setLoginLoading(false)
    }
  }

  const loginCoverImage =
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=800&fit=crop'

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="bg-muted relative hidden lg:block">
        <img
          src={loginCoverImage}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-60 dark:opacity-50 dark:brightness-[0.85] dark:saturate-110"
        />
        <div
          className="absolute inset-0 bg-orange-400/25 mix-blend-multiply dark:bg-amber-600/30"
          aria-hidden
        />
      </div>
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="/" className="flex items-center gap-2 font-medium">
            <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
              <GalleryVerticalEnd className="size-4" />
            </div>
            בונה הערכת מועמדים
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginForm
              onSubmit={handleLogin}
              error={loginError}
              loading={loginLoading}
              useUsername
            />
          </div>
        </div>
      </div>
    </div>
  )
}
